import React, { useEffect, useState } from 'react';
import { Navbar, Dropdown, Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'; // Điều hướng
import { FaBars } from 'react-icons/fa';
import UserService from '../../services/UserService'; // Import UserService

const HeaderComponent = ({ setIsLoggedIn, toggleSidebar }) => {
  const [currentTime, setCurrentTime] = useState('');
  const name = localStorage.getItem('name') || 'Guest'; // Lấy tên từ localStorage
  const navigate = useNavigate(); // Khởi tạo useNavigate để điều hướng

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date();
      const formattedTime = now.toLocaleString('vi-VN', {
        timeZone: 'Asia/Ho_Chi_Minh',
      });
      setCurrentTime(formattedTime);
    }, 1000);

    return () => clearInterval(intervalId); // Cleanup interval khi unmount
  }, []);

  // Hàm xóa tất cả các cookies
  const clearCookies = () => {
    const cookies = document.cookie.split(";");

    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

      // Xóa cookie với path và domain tương ứng
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${window.location.hostname};`;
      // Xóa thêm phiên bản có thể với secure flag (nếu cookie được đặt với secure)
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=${window.location.hostname};secure;`;
    }
  };

  // Hàm xử lý đăng xuất
  const handleLogout = async () => {
    try {
      // Gọi API để xóa session từ server
      const result = await UserService.logout();

      if (result.success) {
        // Xóa localStorage sau khi API thành công
        localStorage.clear();
        clearCookies(); // Xóa tất cả cookies nếu cần
        setIsLoggedIn(false); // Cập nhật trạng thái đăng nhập
        navigate('/login'); // Điều hướng về trang login
      } else {
        alert('Đăng xuất thất bại!'); // Hiển thị lỗi nếu có vấn đề khi đăng xuất
      }
    } catch (error) {
      console.error('Error during logout:', error);
      alert('Có lỗi xảy ra khi đăng xuất.');
    }
  };

  // Điều hướng đến trang đổi mật khẩu
  const handleChangePassword = () => {
    navigate('/change-password');
  };

  return (
    <Navbar bg="danger" variant="dark" expand="lg" className="px-3">
      <Container fluid className="d-flex justify-content-between">
        {/* Nút toggle chỉ hiển thị trên mobile */}
        <Button
          className="d-lg-none position-absolute"
          style={{
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '40px',
            height: 'auto',
          }}
          variant="outline-light"
          onClick={toggleSidebar} // Gọi hàm toggleSidebar để mở/đóng sidebar
        >
          <FaBars />
        </Button>

        {/* Logo */}
        <Navbar.Brand className="mx-auto d-lg-none">
          <img
            src="/images/logo.png"
            alt="Logo"
            width="auto"
            height="60"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>

        <Dropdown align="end">
          <Dropdown.Toggle variant="outline-light" id="dropdown-basic" className=" d-lg-none d-flex" style={{ alignItems: 'center' }}>
            {name.split(' ').slice(-2).join(' ')}
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item onClick={handleChangePassword}>Đổi mật khẩu</Dropdown.Item> {/* Điều hướng đến trang đổi mật khẩu */}
            <Dropdown.Item onClick={handleLogout}>Đăng xuất</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        {/* Logo khi ở desktop */}
        <Navbar.Brand className="d-none d-lg-flex align-items-center">
          <Button
            variant="outline-light"
            className="ms-3 d-none d-lg-inline-block me-3"
            onClick={toggleSidebar}
            title="Mở/tắt sidebar"
          >
            <FaBars />
          </Button>
          <img
            src="/images/logo.png"
            alt="Logo"
            width="auto"
            height="60"
            className="d-inline-block align-top"
          />
        </Navbar.Brand>

        {/* Thời gian chỉ hiển thị trên desktop */}
        <Navbar.Collapse className="justify-content-end d-none d-lg-flex">
          <Navbar.Text className="me-3 text-light">
            {currentTime}
          </Navbar.Text>

          <Dropdown align="end">
            <Dropdown.Toggle variant="outline-light" id="dropdown-basic">
              {name.split(' ').slice(-2).join(' ')}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={handleChangePassword}>Đổi mật khẩu</Dropdown.Item> {/* Điều hướng đến trang đổi mật khẩu */}
              <Dropdown.Item onClick={handleLogout}>Đăng xuất</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default HeaderComponent;
